<template>
    <div class="relative emoji">
        <div v-for="(item, index) in imgs" :key="index">
            <div class="absolute thumbnail" :id="'img_'+index">
                <img class="img-responsive" v-parallax="0.2" :src="item" alt="">
            </div>     
        </div>       
    </div>
</template>

<style scoped>
    .emoji{
        display: block;
    }
    #img_0,
    #img_1,
    #img_2
    {
        z-index: 500
    }
    #img_0{
        -webkit-transform: rotateZ(-30deg);
                transform: rotateZ(-30deg);
        top: -320px;
        left: -120px;
    }
    #img_0 img{
        width: 60%
   }
    #img_1{
        top: 350px;
        right: 30px;
        transform: rotateZ(25deg);
    }
    #img_1 img{
        width: 200%;
    }
    #img_2{
        top: 800px;
        transform: rotateZ(-20deg);
        right: 200px;
    }

    @media only screen and (max-width: 768px){
        .emoji{
            display: none;
        }
    }    
    
    @media only screen and (max-width: 767px){
        #img_1 img{
            width: 75px;
        }
        #img_0, #img_3{
            width: 100px
        }
        #img_3{
            top: 1500px;
            right: -30px;
            -webkit-transform: rotateZ(-30deg);
                    transform: rotateZ(-30deg);
        }
        .thumbnail img{
            width: 60px;
        }
    }
</style>

<script>

// import $ from 'jquery'

export default {
    data() {
        return {
            imgs:[
                require('@/assets/home/emoji/Imagem_1.png'),
                require('@/assets/home/emoji/Imagem_5.png'),
                require('@/assets/home/emoji/Imagem_3.png'),
            ]
        }
    },
}
</script>